import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@redshelf/redshelf-ui';
import { Popover, IconButton, makeStyles } from '@material-ui/core';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';

const useStyles = makeStyles((theme) => {
  return {
    popover: {
      pointerEvents: 'none',
    },
    paper: {
      padding: theme.spacing(1.5),
      maxWidth: '250px',
    },
  };
});

const InfoPopover = ({ description, ...props }) => {
  const classes = useStyles(props);

  const [anchorEl, setAnchorEl] = useState(null);

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <React.Fragment>
      <IconButton
        className="Mui-focused"
        aria-owns={open ? 'mouse-over-popover' : undefined}
        aria-haspopup="true"
        aria-label="informational popup"
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
        onClick={handlePopoverOpen}
        {...props}
      >
        <InfoOutlinedIcon />
      </IconButton>
      <Popover
        id="mouse-over-popover"
        className={classes.popover}
        classes={{
          paper: classes.paper,
        }}
        elevation={16}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        onClose={handlePopoverClose}
        onBlur={handlePopoverClose}
        disableAutoFocus
      >
        <Typography variant="body2">{description}</Typography>
      </Popover>
    </React.Fragment>
  );
};

InfoPopover.propTypes = {
  /**
   * the description for the tooltip
   */
  description: PropTypes.string.isRequired,

  // TODO: update props to be able to easily extend IconButton, Icon, etc.
  /**
   * Optional prop to control the icon button
   */
  // ButtonProps: PropTypes.object() // like 'size'
  /**
   * Optional prop to control the icon
   */
  // IconProps: PropTypes.object(), // like, 'fontSize'
};

InfoPopover.defaultProps = {};

export default InfoPopover;
